import { Navigate, useParams, type RouteObject } from "react-router-dom";

// Redirects
const RedirectHub = () => {
  const { hubsSlug } = useParams();
  return <Navigate to={`/h/${hubsSlug}`} replace />;
};

const RedirectCategory = () => {
  const { categorySlug } = useParams();
  return <Navigate to={`/c/${categorySlug}`} replace />;
};

const RedirectBrand = () => {
  const { brandSlug } = useParams();
  return <Navigate to={`/b/${brandSlug}`} replace />;
};

const RedirectProduct = () => {
  const { productSlug } = useParams();
  return <Navigate to={`/p/${productSlug}`} replace />;
};

const RedirectHome = () => {
  return <Navigate to={`/`} replace />;
};

const publicRoutes: RouteObject[] = [
  {
    index: true,
    lazy: async () => {
      const { default: Home } = await import("@pages/Home");
      return {
        element: <Home />,
      };
    },
  },
  {
    path: "search",
    lazy: async () => {
      const { loader, default: Search } = await import("@pages/Search");
      return {
        loader,
        element: <Search />,
      };
    },
  },
  {
    path: "/p/:productSlug",
    lazy: async () => {
      const { default: Product } = await import("@/Pages/Product");
      return {
        element: <Product />,
      };
    },
  },
  {
    path: "c/:categorySlug",
    lazy: async () => {
      const { loader, default: Category } = await import("@/Pages/Category");
      return {
        loader,
        element: <Category />,
      };
    },
  },
  {
    path: "h/:hubSlug",
    lazy: async () => {
      const { loader, default: Hub } = await import("@/Pages/Hub");
      return {
        loader,
        element: <Hub />,
      };
    },
  },
  {
    path: "b/:brandSlug",
    lazy: async () => {
      const { loader, default: Brand } = await import("@/Pages/Brand");
      return {
        loader,
        element: <Brand />,
      };
    },
  },
  {
    path: "stores",
    lazy: async () => {
      const { default: Stores } = await import("@/Pages/Stores");
      return {
        element: <Stores />,
      };
    },
  },
  {
    path: "/tiendas",
    element: <Navigate to="/stores" replace />,
  },
  // Redirects from old pages
  {
    path: "stores/:type/",
    Component: RedirectHome,
  },
  {
    path: "gift-cards/buy",
    element: <Navigate to="/gift-cards/redeem" replace />,
  },
  {
    path: "stores/:type/c/:categorySlug",
    Component: RedirectCategory,
  },
  {
    path: "stores/:type/c/:categorySlug/:categorySlug",
    Component: RedirectCategory,
  },
  {
    path: "stores/:type/b/:brandSlug",
    Component: RedirectBrand,
  },
  {
    path: "stores/:type/h/:hubsSlug",
    Component: RedirectHub,
  },
  {
    path: "stores/:type/p/:productSlug",
    Component: RedirectProduct,
  },
  {
    path: "stores/restaurant",
    element: <Navigate to="/stores/market/c/restaurante" replace />,
  },
  {
    path: "terms",
    lazy: async () => {
      const { default: TermsAndConditions } = await import("@/Pages/TermsAndConditions");
      return {
        element: <TermsAndConditions />,
      };
    },
  },
  {
    path: "policy",
    lazy: async () => {
      const { default: Policy } = await import("@/Pages/Policy");
      return {
        element: <Policy />,
      };
    },
  },
  {
    path: "gift-cards/redeem",
    lazy: async () => {
      const { default: RedeemGiftCard } = await import("@/Pages/GiftCardRedeem");
      return {
        element: <RedeemGiftCard />,
      };
    },
  },
  {
    path: "promo/:id",
    lazy: async () => {
      const { default: Promo, loader } = await import("@/Pages/Promo");
      return {
        loader,
        element: <Promo />,
      };
    },
  },
  // {
  //   path: "flash",
  //   lazy: async () => {
  //     const { default: Flash } = await import("@/Pages/Flash");
  //     return {
  //       element: <Flash />,
  //     };
  //   },
  // },
  {
    path: "referred",
    lazy: async () => {
      const referredModule = import("@/Pages/Referred");
      const errorModule = import("@/Pages/Error404");

      const [{ default: Referred, loader }, { default: Error404 }] = await Promise.all([
        referredModule,
        errorModule,
      ]);

      return {
        loader,
        Component: Referred,
        shouldRevalidate: () => true,
        errorElement: <Error404 withHeader={false} />,
      };
    },
  },
];

export { publicRoutes };
